<template>
  <div class="magnetic-induction-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>F = B · I · L sinθ$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- Magnetic Field Lines (Vertical) -->
          <g>
            <line v-for="x in 10" :key="'lx'+x" :x1="x*40" y1="20" :x2="x*40" y2="220" stroke="rgba(0, 210, 255, 0.15)" stroke-width="1" marker-end="url(#b-arrow)" />
          </g>

          <!-- Current-carrying wire -->
          <g :transform="`translate(200, 120) rotate(${angle})`">
             <line x1="-80" y1="0" x2="80" y2="0" stroke="#ff4757" stroke-width="4" />
             <path d="M -60,-10 L -40,0 L -60,10" fill="none" stroke="#ff4757" />
             <text x="-70" y="-15" fill="#ff4757" font-size="10">电流 I</text>
          </g>

          <!-- Force Vector (Lorentz/Ampere) -->
          <!-- Direction depends on I cross B (Hand rule) -->
          <g v-if="forceMag > 0">
             <!-- Z-axis indicator: Cross (into) or Dot (out) -->
             <circle cx="200" cy="120" r="15" fill="none" :stroke="forceDir > 0 ? '#ffd700' : '#2ed573'" stroke-width="2" />
             <g v-if="forceDir > 0"> <!-- Cross: into paper -->
                <line x1="192" y1="112" x2="208" y2="128" stroke="#ffd700" />
                <line x1="208" y1="112" x2="192" y2="128" stroke="#ffd700" />
                <text x="220" y="115" fill="#ffd700" font-size="10">安培力 (×) 向内</text>
             </g>
             <g v-else> <!-- Dot: out of paper -->
                <circle cx="200" cy="120" r="3" fill="#2ed573" />
                <text x="220" y="115" fill="#2ed573" font-size="10">安培力 (·) 向外</text>
             </g>
          </g>

          <defs>
            <marker id="b-arrow" markerWidth="8" markerHeight="6" refX="0" refY="3" orient="auto">
              <polygon points="0 0, 8 3, 0 6" fill="rgba(0, 210, 255, 0.3)" />
            </marker>
          </defs>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>力的大小 F = {{ forceMag.toFixed(2) }} N</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row">
             <label>磁场强度 B: {{ fieldB }} T</label>
             <el-slider v-model="fieldB" :min="1" :max="10" size="mini"></el-slider>
          </div>
          <div class="row">
             <label>电流夹角 θ: {{ angle }}°</label>
             <el-slider v-model="angle" :min="0" :max="180" size="mini"></el-slider>
          </div>
        </div>

        <div class="discovery-note" v-latex>
          <p><strong>物理详解：</strong>磁感应强度 B 是描述磁场强弱和方向的物理量。安培力是磁场对电流的作用力。通过**左手定则**可以判断：磁感线穿过掌心，四指指向电流，大拇指即为受力方向。当导线与磁场平行时，受力为零。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MagneticInductionViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      fieldB: 5,
      angle: 90
    }
  },
  computed: {
    forceMag() {
      // B * I * L * sin(theta). Using simplified values for visual.
      return this.fieldB * Math.abs(Math.sin(this.angle * Math.PI / 180));
    },
    forceDir() {
       // Simplified logic for inward/outward
       return Math.sin(this.angle * Math.PI / 180) > 0 ? 1 : -1;
    }
  }
}
</script>

<style scoped lang="scss">
.magnetic-induction-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; 
  label { font-size: 0.7rem; color: #888; display: block; margin-bottom: 5px; } 
}
.discovery-note { background: rgba(0, 210, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
